import React, { FC, useState } from 'react';
import Button from 'components/Button/Index';
import { ICompanylogo } from 'core/interface/companyLogo';
import Activation from '../Index';
import ImagePicker from 'components/imagePicker';

import './index.scss';

interface ActivationCompanyLogoProps extends ICompanylogo {
  currentStep: number;
  totalSteps: number;
}

const ActivationCompanyLogo: FC<ActivationCompanyLogoProps> = ({
  t,
  onSubmit,
  setCompanyData,
  onBack,
  currentStep,
  totalSteps
}): JSX.Element => {
  const [logo, setLogo] = useState<File | null>(null);

  const handleLogoSave = async (): Promise<void> => {
    if (logo) {
      setCompanyData((prev: any) => ({
        ...prev,
        logo
      }));
      onSubmit();
    }
  };

  return (
    <Activation
      title={t('Company logo')}
      currentStep={currentStep}
      totalSteps={totalSteps}
    >
      <div className="av">
        <div className="av__content">
          <ImagePicker
            setLogo={(file: File) => setLogo(file)}
            logo={logo}
            max={1}
          />
          <div className="av__content__buttons">
            <Button
              onClick={onBack}
              t={t}
              title="Back"
              className="av__content__buttons-back"
            />
            <Button
              onClick={handleLogoSave}
              t={t}
              title="Next"
              className={`av__content__buttons-next ${!logo ? 'deactive' : ''}`}
              disabled={!logo}
            />
          </div>
        </div>
      </div>
    </Activation>
  );
};

export default ActivationCompanyLogo;
